//-------------------REGISTRAR INVENTARIO--------------------------//
//------------(PASO 1)--------------//
// Acción de carga obtener todos los datos del paso 1
export const RECEPCION_REQUEST = 'RECEPCION_REQUEST';
export const RECEPCION_SUCCESS = 'RECEPCION_SUCCESS';
export const RECEPCION_FAIL = 'RECEPCION_FAIL';

// Acción de carga lista inventario registrado
export const LISTA_INVENTARIO_REGISTRADO_REQUEST = 'LISTA_INVENTARIO_REGISTRADO_REQUEST';
export const LISTA_INVENTARIO_REGISTRADO_SUCCESS = 'LISTA_INVENTARIO_REGISTRADO_SUCCESS';
export const LISTA_INVENTARIO_REGISTRADO_FAIL = 'LISTA_INVENTARIO_REGISTRADO_FAIL';

// Acción de carga combo origen presupuesto
export const ORIGEN_REQUEST = 'ORIGEN_REQUEST';
export const ORIGEN_SUCCESS = 'ORIGEN_SUCCESS';
export const ORIGEN_FAIL = 'ORIGEN_FAIL';

// Acción de carga combo COMBO_PROVEEDORES 
export const COMBO_PROVEEDORES_REQUEST = 'COMBO_PROVEEDORES_REQUEST';
export const COMBO_PROVEEDORES_SUCCESS = 'COMBO_PROVEEDORES_SUCCESS';
export const COMBO_PROVEEDORES_FAIL = 'COMBO_PROVEEDORES_FAIL';

// Acción de carga combo modalidad compra
export const MODALIDAD_COMPRA_REQUEST = 'MODALIDAD_COMPRA_REQUEST';
export const MODALIDAD_COMPRA_SUCCESS = 'MODALIDAD_COMPRA_SUCCESS';
export const MODALIDAD_COMPRA_FAIL = 'MODALIDAD_COMPRA_FAIL';

// Acción de carga servicio nombre
export const OBTENER_SERVICIO_NOMBRE_REQUEST = 'OBTENER_SERVICIO_NOMBRE_REQUEST';
export const OBTENER_SERVICIO_NOMBRE_SUCCESS = 'OBTENER_SERVICIO_NOMBRE_SUCCESS';
export const OBTENER_SERVICIO_NOMBRE_FAIL = 'OBTENER_SERVICIO_NOMBRE_FAIL';

//------------(PASO 2)--------------//
// Acción de carga combo servicio
export const SERVICIO_REQUEST = 'SERVICIO_REQUEST';
export const SERVICIO_SUCCESS = 'SERVICIO_SUCCESS';
export const SERVICIO_FAIL = 'SERVICIO_FAIL';

// Acción de carga combo dependencia
export const DEPENDENCIA_REQUEST = 'DEPENDENCIA_REQUEST';
export const DEPENDENCIA_SUCCESS = 'DEPENDENCIA_SUCCESS';
export const DEPENDENCIA_FAIL = 'DEPENDENCIA_FAIL';


// Acción de carga listado de especies
export const LISTADO_ESPECIES_BIEN_REQUEST = 'LISTADO_ESPECIES_BIEN_REQUEST';
export const LISTADO_ESPECIES_BIEN_SUCCESS = 'LISTADO_ESPECIES_BIEN_SUCCESS';
export const LISTADO_ESPECIES_BIEN_FAIL = 'LISTADO_ESPECIES_BIEN_FAIL';

// Acción de carga combo de especies
export const COMBO_ESPECIES_BIEN_REQUEST = 'COMBO_ESPECIES_BIEN_REQUEST';
export const COMBO_ESPECIES_BIEN_SUCCESS = 'COMBO_ESPECIES_BIEN_SUCCESS';
export const COMBO_ESPECIES_BIEN_FAIL = 'COMBO_ESPECIES_BIEN_FAIL';

// Acción de carga combo cuenta
export const CUENTA_REQUEST = 'CUENTA_REQUEST';
export const CUENTA_SUCCESS = 'CUENTA_SUCCESS';
export const CUENTA_FAIL = 'CUENTA_FAIL';

// Acción de carga combo bien
export const BIEN_REQUEST = 'BIEN_REQUEST';
export const BIEN_SUCCESS = 'BIEN_SUCCESS';
export const BIEN_FAIL = 'BIEN_FAIL';

// Acción de carga combo detalles
export const BIEN_DETALLES_REQUEST = 'BIEN_DETALLES_REQUEST';
export const BIEN_DETALLES_SUCCESS = 'BIEN_DETALLES_SUCCESS';
export const BIEN_DETALLES_FAIL = 'BIEN_DETALLES_FAIL';

//------------(PASO 3)--------------//
// export const SET_TOTAL_ACTIVO_FIJO = 'SET_TOTAL_ACTIVO_FIJO';
// Acción de post formulario inventario
export const POST_FORMULARIO_REQUEST = 'POST_FORMULARIO_REQUEST';
export const POST_FORMULARIO_SUCCESS = 'POST_FORMULARIO_SUCCESS';
export const POST_FORMULARIO_FAIL = 'POST_FORMULARIO_FAIL';

// Acción Post bienes de funcionarios
export const OBTENER_MAX_INVENTARIO_REQUEST = 'OBTENER_MAX_INVENTARIO_REQUEST';
export const OBTENER_MAX_INVENTARIO_SUCCESS = 'OBTENER_MAX_INVENTARIO_SUCCESS';
export const OBTENER_MAX_INVENTARIO_FAIL = 'OBTENER_MAX_INVENTARIO_FAIL';


//-------------------MODIFICACAR INVENTARIO--------------------------//

// Acción para actualizar formulario
export const ACTUALIZAR_FORMULARIO_REQUEST = 'ACTUALIZAR_FORMULARIO_REQUEST';
export const ACTUALIZAR_FORMULARIO_SUCCESS = 'ACTUALIZAR_FORMULARIO_SUCCESS';
export const ACTUALIZAR_FORMULARIO_FAIL = 'ACTUALIZAR_FORMULARIO_FAIL';

// Acción obtener todos los datos de formulario inventario por af_codigo_generico
export const OBTENER_INVENTARIO_REQUEST = 'OBTENER_INVENTARIO_REQUEST';
export const OBTENER_INVENTARIO_SUCCESS = 'OBTENER_INVENTARIO_SUCCESS';
export const OBTENER_INVENTARIO_FAIL = 'OBTENER_INVENTARIO_FAIL';

// Acción obtener todos los datos de formulario inventario por altas_corr
export const OBTENER_INVENTARIO_X_ALTAS_REQUEST = 'OBTENER_INVENTARIO_X_ALTAS_REQUEST';
export const OBTENER_INVENTARIO_X_ALTAS_SUCCESS = 'OBTENER_INVENTARIO_X_ALTAS_SUCCESS';
export const OBTENER_INVENTARIO_X_ALTAS_FAIL = 'OBTENER_INVENTARIO_X_ALTAS_FAIL';

// Acción de carga combo dependencia
export const DEPENDENCIA_MODIFICAR_REQUEST = 'DEPENDENCIA_MODIFICAR_REQUEST';
export const DEPENDENCIA_MODIFICAR_SUCCESS = 'DEPENDENCIA_MODIFICAR_SUCCESS';
export const DEPENDENCIA_MODIFICAR_FAIL = 'DEPENDENCIA_MODIFICAR_FAIL';

// Acción de carga combo cuenta
export const CUENTA_MODIFICAR_REQUEST = 'CUENTA_MODIFICAR_REQUEST';
export const CUENTA_MODIFICAR_SUCCESS = 'CUENTA_MODIFICAR_SUCCESS';
export const CUENTA_MODIFICAR_FAIL = 'CUENTA_MODIFICAR_FAIL';

// Acción trae combo servicio dependencia
export const COMBO_SER_DEP_MODIFICAR_REQUEST = 'COMBO_SER_DEP_MODIFICAR_REQUEST';
export const COMBO_SER_DEP_MODIFICAR_SUCCESS = 'COMBO_SER_DEP_MODIFICAR_SUCCESS';
export const COMBO_SER_DEP_MODIFICAR_FAIL = 'COMBO_SER_DEP_MODIFICAR_FAIL';

//-------------------ANULAR INVENTARIO--------------------------//
// Acción de carga lista inventario
export const LISTA_INVENTARIO_ANULAR_REQUEST = 'LISTA_INVENTARIO_ANULAR_REQUEST';
export const LISTA_INVENTARIO_ANULAR_SUCCESS = 'LISTA_INVENTARIO_ANULAR_SUCCESS';
export const LISTA_INVENTARIO_ANULAR_FAIL = 'LISTA_INVENTARIO_ANULAR_FAIL';

// Acción anula inventario
export const ANULAR_INVENTARIO_REQUEST = 'ANULAR_INVENTARIO_REQUEST';
export const ANULAR_INVENTARIO_SUCCESS = 'ANULAR_INVENTARIO_SUCCESS';
export const ANULAR_INVENTARIO_FAIL = 'ANULAR_INVENTARIO_FAIL';

//-------------------BUSCAR INVENTARIO------------------------------//
export const LISTA_INVENTARIO_BUSCAR_REQUEST = 'LISTA_INVENTARIO_BUSCAR_REQUEST';
export const LISTA_INVENTARIO_BUSCAR_SUCCESS = 'LISTA_INVENTARIO_BUSCAR_SUCCESS';
export const LISTA_INVENTARIO_BUSCAR_FAIL = 'LISTA_INVENTARIO_BUSCAR_FAIL';

//-------------------BIENES FUNCIONARIOS--------------------------//
// Acción Post bienes de funcionarios
export const POST_FORMULARIO_BIENES_REQUEST = 'POST_FORMULARIO_BIENES_REQUEST';
export const POST_FORMULARIO_BIENES_SUCCESS = 'POST_FORMULARIO_BIENES_SUCCESS';
export const POST_FORMULARIO_BIENES_FAIL = 'POST_FORMULARIO_BIENES_FAIL';

// Acción trae bienes de funcionarios segun numero de cuenta 5321001
export const LISTA_BIENES_FUNCIONARIOS_REQUEST = 'LISTA_BIENES_FUNCIONARIOS_REQUEST';
export const LISTA_BIENES_FUNCIONARIOS_SUCCESS = 'LISTA_BIENES_FUNCIONARIOS_SUCCESS';
export const LISTA_BIENES_FUNCIONARIOS_FAIL = 'LISTA_BIENES_FUNCIONARIOS_FAIL';

// Acción busca bienes de funcionarios antes de ser registrados
export const BUSCAR_BIENES_FUNCIONARIOS_REQUEST = 'BUSCAR_BIENES_FUNCIONARIOS_REQUEST';
export const BUSCAR_BIENES_FUNCIONARIOS_SUCCESS = 'BUSCAR_BIENES_FUNCIONARIOS_SUCCESS';
export const BUSCAR_BIENES_FUNCIONARIOS_FAIL = 'BUSCAR_BIENES_FUNCIONARIOS_FAIL';

// Acción trae máximo bienes de funcionarios segun numero de cuenta 5321001
export const MAX_BIENES_FUNCIONARIOS_REQUEST = 'MAX_BIENES_FUNCIONARIOS_REQUEST';
export const MAX_BIENES_FUNCIONARIOS_SUCCESS = 'MAX_BIENES_FUNCIONARIOS_SUCCESS';
export const MAX_BIENES_FUNCIONARIOS_FAIL = 'MAX_BIENES_FUNCIONARIOS_FAIL';

//-------------------LISTA INVENTARIO QR------------------------------//
export const OBTIENE_INV_QR_REQUEST = 'OBTIENE_INV_QR_REQUEST';
export const OBTIENE_INV_QR_SUCCESS = 'OBTIENE_INV_QR_SUCCESS';
export const OBTIENE_INV_QR_FAIL = 'OBTIENE_INV_QR_FAIL';

//Acción que permite registrar nuevas modalidades
export const REGISTRAR_MODALIDAD_REQUEST = 'REGISTRAR_MODALIDAD_REQUEST';
export const REGISTRAR_MODALIDAD_SUCCESS = 'REGISTRAR_MODALIDAD_SUCCESS';
export const REGISTRAR_MODALIDAD_FAIL = 'REGISTRAR_MODALIDAD_FAIL';
